(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionPrimaryAccessDeleteController',InfectionPrimaryAccessDeleteController);

    InfectionPrimaryAccessDeleteController.$inject = ['$uibModalInstance', 'entity', 'InfectionPrimaryAccess'];

    function InfectionPrimaryAccessDeleteController($uibModalInstance, entity, InfectionPrimaryAccess) {
        var vm = this;

        vm.infectionPrimaryAccess = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InfectionPrimaryAccess.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
